const FETCH_STORIES = 'curationList/FETCH_STORIES';
const FETCH_SECTION_BANNERS = 'curationList/FETCH_SECTION_BANNERS';

const RESET = 'curationList/RESET';


export default {
  FETCH_STORIES,
  FETCH_SECTION_BANNERS,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/curationList/types.js